import { signIn } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { useContext, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { mutate } from 'swr'
import { PasswordInput } from 'components/Form/PasswordInput'
import { UserActionsContext } from 'components/User/UserActionsContext'
import { Button } from 'components/common/Button'
import { ButtonVariant } from 'components/common/Button/ButtonVariant'
import { Loader } from 'components/common/Loader'
import { TextInput } from 'components/common/TextInput'
import { apiClient } from 'services/api/client'
import { AuthModalContext } from './AuthModalContext'
import { SignInFormValues } from './SignInFormValues'

export const SignInForm = () => {
  const {
    modalParams: { redirectUrl },
    setModalParams
  } = useContext(AuthModalContext)
  const [isLoading, setIsLoading] = useState(false)
  const [signInError, setSignInError] = useState<string | undefined>(undefined)
  const { eventId, setEventId } = useContext(UserActionsContext)

  const onSubmit = async ({ email, password }: SignInFormValues) => {
    setIsLoading(true)
    const signInResponse = await signIn('signIn', {
      email,
      password,
      callbackUrl: redirectUrl,
      redirect: false
    })
    if (signInResponse?.ok) {
      if (!!eventId) {
        await apiClient.post(`/user-event-favorite/${eventId}`)
        mutate('user-event-favorites')
        setEventId(null)
      }
      window.open(redirectUrl, '_self')
    } else if (signInResponse?.error === 'CredentialsSignin') {
      setSignInError(t('login.form.error.credentials'))
    } else if (signInResponse?.error === 'No User found') {
      setModalParams({
        state: 'SIGNUP',
        redirectUrl,
        email
      })
    } else {
      setSignInError(t('login.form.error.unknown'))
    }
    setIsLoading(false)
  }

  const {
    handleSubmit,
    formState: { errors },
    register
  } = useFormContext<SignInFormValues>()
  const { t } = useTranslation('authentication')

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        width: '100%'
      }}
    >
      <TextInput
        fullSize
        inputProps={{
          ...register('email'),
          autoComplete: 'email',
          required: true
        }}
        inputLabel={t('login.form.email.label')}
        errorMessage={errors.email?.message}
      />
      <PasswordInput<SignInFormValues>
        register={register}
        name="password"
        errors={errors}
        customErrorMessage={signInError}
      />
      <Button
        variant={ButtonVariant.Primary}
        fullWidth
        label={t('login.button.submit')}
        leftIcon={isLoading ? <Loader /> : undefined}
        disabled={isLoading}
        type="submit"
      />
    </form>
  )
}
